export default "__VITE_ASSET__CP$Sq8ee__"